import { Theme, makeStyles } from '@material-ui/core';

export const useStyles = ({
  focused,
  large,
}: {
  focused: boolean;
  large?: boolean;
}) =>
  makeStyles(({ custom, palette }: Theme) => ({
    euroband: {
      position: 'absolute',
      zIndex: 2,
      height: '100%',
      width: large ? 40 : 32,
      background: '#1c4ab2 url("./images/misc/euroband.svg") no-repeat center',
      borderTopLeftRadius: 5,
      borderBottomLeftRadius: 5,
      '&::after': {
        height: 1,
        content: '""',
      },
    },
    eurobandDisabled: {
      opacity: 0.5,
    },

    adornedStart: {
      paddingLeft: 0,
    },
    eurobandFocused: {
      height: 'calc(100% + 1px)',
      top: -1,
    },
    textField: {
      '& label': {
        ...(large && { fontSize: 18, marginTop: 4 }),
      },
      '& .MuiOutlinedInput-notchedOutline': {
        transition: 'none',
      },
      '& .MuiOutlinedInput-notchedOutline legend': {
        transition: 'none',
      },

      '&:hover': {
        '& $euroband::after': {
          transition: 'background 300ms ease',
          background: focused ? palette.primary.main : custom.grey[2],
          height: focused ? 2 : 1,
        },
        '& $euroband$eurobandDisabled::after': {
          background: 'none',
        },
      },
      '& $euroband::after': {
        transition: 'all 300ms ease',
        display: 'inline-block',
        width: 14,
        top: 0,
        right: -14,
        position: 'absolute',
        height: focused ? 2 : 1,
        background: focused ? palette.primary.main : custom.grey[1],
      },
      '& $euroband$eurobandDisabled::after': {
        background: 'none',
      },
      '& $euroband::before': {
        transition: 'all 300ms ease',
        content: '""',
        display: 'inline-block',
        width: large ? 40 : 32,
        top: 1.5,
        right: -8,
        position: 'absolute',
        background: 'transparent',
        height: 1,
      },
      '& .Mui-error $euroband': {
        height: 'calc(100% + 1.5px)',
        top: -1.5,
      },
      '& .Mui-error $euroband::after': {
        transition: 'all 300ms ease',
        background: `${custom.status.danger.contrastText} !important`,
        width: 14,
        top: 0,
        height: '4px !important',
      },
      '& .Mui-error $euroband::before': {
        display: 'none',
        transition: 'all 300ms ease',
        background: `${custom.status.danger.contrastText} !important`,
        top: -1.5,
        height: 1.5,
      },
    },
    input: {
      marginLeft: large ? 55 : 47,
      ...(large && { fontSize: 18, paddingTop: 20, paddingBottom: 20 }),
    },
    doneAdornment: {
      marginLeft: large ? 51 : 43,
      marginRight: large ? -47 : -39,
    },
    inputLabel: {
      marginLeft: large ? 40 : 32,
      paddingRight: 6,
      paddingLeft: 6,
      '&.shrink': {
        ...(large && { top: -4 }),
      },
      '&.Mui-error.shrink': {
        ...(large
          ? {
              top: -5.6,
            }
          : {
              top: -1.4,
            }),
      },
    },
  }));
